import React from 'react';
import PessoaEnvolvida from './PessoaEnvolvida';
import { FaUserPlus } from "react-icons/fa";
import ValidaEnvolvidos from './ValidaEnvolvidos'

export default function PessoasEnvolvidas(props) {

    const acrescentarPessoaEnvolvida = () => {
        const maisUmaPessoa = { nome:'', cargo:'', areaDepartamento:'' };
        const pessoasEnvolvidas = props.pessoasEnvolvidas.concat(maisUmaPessoa);
        props.setPessoasEnvolvidas([]);
        props.setPessoasEnvolvidas(pessoasEnvolvidas);
    }

    const removerPessoaEnvolvida = index => {
        const pessoasEnvolvidas = [];
        for (let i=0; i<props.pessoasEnvolvidas.length; i++) {
            if (i !== index) {
                pessoasEnvolvidas.push(props.pessoasEnvolvidas[i]);
            }
        }
        props.setPessoasEnvolvidas([]);
        props.setPessoasEnvolvidas(pessoasEnvolvidas);
    }

    const atualizarPessoaEnvolvida = (rotulo,valor,index) => {
        const pessoasEnvolvidas = [].concat(props.pessoasEnvolvidas);
        pessoasEnvolvidas[index] = { ...pessoasEnvolvidas[index], [rotulo]:valor };
        props.setPessoasEnvolvidas([]);
        props.setPessoasEnvolvidas(pessoasEnvolvidas);
    }

    const renderPessoasEnvolvidas = () => {
        if (!props.pessoasEnvolvidas) {
            return null;
        }
        if (props.pessoasEnvolvidas.length === 0) {
            return null;
        }
        
        return props.pessoasEnvolvidas.map( (envolvidoOuEnvolvida, index) => {
            return (
                <PessoaEnvolvida 
                    key={ "keyEnvolvido_" + index }
                    pessoaEnvolvida={ envolvidoOuEnvolvida }
                    acrescentarPessoaEnvolvida={ acrescentarPessoaEnvolvida } 
                    removerPessoaEnvolvida={ removerPessoaEnvolvida } 
                    atualizarPessoaEnvolvida={ atualizarPessoaEnvolvida }
                    indice={ index } 
                />
            );
        });
    }

    const abreFormularioNarrativa = () => {
        props.setMensagem({ tipo:'LIMPAR', texto:'' })
        ValidaEnvolvidos.valida(props.pessoasEnvolvidas)
        .then( pessoasEnvolvidas => {
            props.setPessoasEnvolvidas(pessoasEnvolvidas)
            props.atuLinhaDoTempo('narrativa')
        })
        .catch( msgErro => {
            props.setMensagem(msgErro)
        })
    }

    const abreFormularioDataOcorrencia = () => {
        props.setMensagem({ tipo:'LIMPAR', texto:'' })
        props.atuLinhaDoTempo('dataHora')
    }

    const secaoPessoasEnvolvidas = () => {
        return (
            <fieldset className="border p-2">
                <legend  className="w-auto">
                    <button className="btn btn-sm" onClick={ () => acrescentarPessoaEnvolvida() } type="button">
                        <h4 className="ml-0">
                            <small>
                                { "Novo: " }
                                <FaUserPlus className="text-primary" /> 
                            </small>
                        </h4> 
                    </button>
                </legend>
                <ul className="list-group list-group-flush">
                    { renderPessoasEnvolvidas() }
                </ul>
            </fieldset>
        );
    }

    if (props.formularioEmPauta === "Nova denúncia" || props.linhaDoTempo.emPauta !== "envolvidos") {
        return null;
    }

    return (
        <fieldset className="border p-2 mt-4">
            <legend className="row w-auto">
                <h4 className="ml-4"><small>Dados dos envolvidos:</small></h4> 
            </legend>
            { secaoPessoasEnvolvidas() }
            <div className="d-flex flex-row justify-content-between mt-4 mb-2">
                <button 
                    type="button" 
                    className="btn btn-outline-primary" 
                    onClick={ abreFormularioDataOcorrencia }
                >
                    Anterior
                </button>
                <button 
                    type="button" 
                    className="btn btn-outline-primary " 
                    onClick={ abreFormularioNarrativa }
                >
                    Próximo
                </button>
            </div>
        </fieldset>
    )
}